<h2>
  Forbidden Access
</h2>

<ui-kit-icon class="forbidden-icon" icon="lock" color="white" size="custom"></ui-kit-icon>

<p class="forbidden-text">
  You are attempting to access a page that your user does not have access to because of its current roles or access
  level.
</p>
<p class="forbidden-text">
  If access to this page is required, please reach out to tech support to have your user’s roles or access level
  updated.
</p>
